import './index.scss'
import { useEffect, useRef, useState } from "react";
import AnimatedLetters from "../AnimatedLatters";
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css'
import { Icon } from 'leaflet';
import emailjs from '@emailjs/browser'
import Loader from 'react-loaders';
import toast from 'react-hot-toast';

export default function Contact(){

    const formRef=useRef()

    function sumbmitForm(form){
        form.preventDefault()
        emailjs.sendForm(
            'service_tpd3rtc',
            'template_7pe22k9',
            formRef.current,
            'H55MmNSwhjdaTKKcT'
        ).then(res=>{
            if(res.status===200){
                toast.success('Thanks for contacting..')
            }
            else{
                toast.error('Please try again!')
            }
        })
    }
    
    const customIcon= new Icon({
        iconUrl: require('../../assets/Images/placeholder.png'),
        iconSize:(38,38),
        
    })
    const [letterClass,setLetterClass]=useState('text-animate')
    useEffect(()=>{
        setTimeout(()=>{
            setLetterClass('text-animate-hover')
        },3000)
    },[])
    return(
        <>   
            <div className="contact-page">
                <div className="contact">
                    <div className="text-zone">
                    <h1>
                        <AnimatedLetters strAry={'Contact'.split('')} letterClass={letterClass} idx={12}/>
                    </h1>    
                        <p className=' '>
                        I am interested in freelance opportunities - especially ambitious or
                        large projects. However, if you have other request or question,
                        don't hesitate to contact me using below form either. 
                        </p>
                        <form ref={formRef} onSubmit={(e)=>{
                            sumbmitForm(e)}}>
                            <ul>
                                <li>
                                    <input required className='half' placeholder='Name' type="text" name="from_name"  />
                                </li>
                                <li>
                                    <input required  className='half' placeholder='E-mail' type="email" name="reply_to" />
                                </li>
                                <li>
                                    <textarea required placeholder='Message' name="message"  ></textarea>
                                </li>
                                <li>
                                    <input className='btn' type="submit" value='SEND'/>
                                </li>
                            </ul>
                        </form>
                    </div>
                    <div className="map">
                    <MapContainer  center={[14.480768361988888, 75.9225189953949]} zoom={13} scrollWheelZoom={false}>
                        <TileLayer
                        // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <Marker icon={customIcon}  position={[14.480768361988888, 75.9225189953949]}>
                            <Popup>
                                <h2>My Current Location</h2>
                            </Popup>
                        </Marker>
                        <Marker icon={customIcon} position={[14.467503827310239, 75.92505340310905]}>
                            <Popup>Center of the city</Popup>
                        </Marker>
                    </MapContainer>
                    </div>
                </div>
            </div>
            <Loader type='pacman'/>
        </>
    )
}